<div *ngIf="isDesktop; else notDesktop">
  <router-outlet></router-outlet>
</div>

<ng-template #notDesktop>
  <div class="unavailable">
    View is available in Desktop Mode Only.
  </div>
</ng-template>
